import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@material-ui/core";
import t from "../../../../../languages/pl";
import CancelAcceptForm from "../../../../Common/CancelAcceptForm";

const useStyles = theme => ({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "24px",
    paddingBottom: theme.spacing(2)
  },
  info: {
    fontWeight: "bold",
    fontSize: "1.3rem",
  },
  explanation: {
    color: "#4977FF",
    fontWeight: "bold",
    fontSize: "1.1rem",
  },
  warning: {
    color: "#FF4A4A",
    fontSize: "1.1rem",
  }

});

const ConfirmationCarActionDialog = props => {
  const {
    classes,
    id,
    action,
    name,
    gpsState,
    open,
    onClose,
    onSubmit
  } = props;

  const handleSubmit = () => {
    if (onSubmit)
      onSubmit(id);
    onClose();
  };


  function explanationText() {
    if (name === "service") {
      return (
        <Fragment>
          <Typography className={classes.explanation}>
            {'TRYB SERWISOWY - tryb pomija wszelką ingerencję urządzenia GPS w możliwość uruchomienia samochodu (nietrzeba używać kart RFID w celu autoryzacji). Dane jazdy nadal są przesyłane na serwer.'}
          </Typography>
        </Fragment>

      );
    } else if (name === "blocked") {
      return (
        <Fragment>
          <Typography className={classes.explanation}>
            {'BLOKADA - włączenie tej funkcji skutkuje zablokowaniem możliwości uruchomienia samochodu przez kierowcę (jest to opcja dodatkowa, może nie być dostępna w Twoich samochodach)'}
          </Typography>
          <Typography className={classes.explanation}>
            {'Jeśli samochód jest w TRAKCIE JAZDY, blokada auta nastąpi po zatrzymaniu i wyłączeniu zapłonu.'}
          </Typography>
        </Fragment>
      );
    } else {
      return null;
    }
  }

  function warningText() {
    if (gpsState === "Rozłączony+" || gpsState === "Rozłączony") {
      return (
        <Fragment>
          <Typography className={classes.warning}>
            {'UWAGA: Serwer aplikacji nie ma połączenia GPRS z samochodem. Dane mogą być nieaktualne. Możliwe przyczyny:'}
          </Typography>

          <Typography className={classes.warning}>
            {'1. Auto jest poza zasięgiem sieci GSM.'},
          </Typography>

          <Typography className={classes.warning}>
            {'2. Brak roamingu danych.'}
          </Typography>

          <Typography className={classes.warning}>
            {'3. Awaria urządzenia.'}
          </Typography>

          <Typography className={classes.warning}>
            {'Jeśli sytuacja trwa dłuższy czas a wiesz, że samochód jest użytkowany, zgłoś problem do administracji QSAFE24Flota: support@ets-polska.pl'}
          </Typography>
        </Fragment>

      );
    } else {
      return null;
    }
  }

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="sm"
      onClose={onClose}
    >
      <DialogTitle>
        {t.confirmation}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography variant="subtitle1" className={classes.info}>
          {t.areYouSure}&nbsp;{action}?
        </Typography>
        {explanationText()}
        {warningText()}
      </DialogContent>
      <DialogActions>
        <CancelAcceptForm onCancel={onClose} onSubmit={handleSubmit}/>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(useStyles)(ConfirmationCarActionDialog);

ConfirmationCarActionDialog.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  action: PropTypes.string,
  name: PropTypes.string,
  gpsState: PropTypes.string,
  onSubmit: PropTypes.func
};
